'use strict';

module.exports = require('./components/inputs/Select').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/Select.js
// module id = 1843
// module chunks = 0